import Button from '../Button/Button';
import React, { useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonType } from 'antd/lib/button/button';
import CancelDeliveryModal from '../CancelDeliveryModal';

interface CancelDeliveryButtonProps {
  onCancel: (reason: string, customReason?: string) => Promise<any>;
  btnType?: ButtonType;
  onCancelAttempt: () => void;
  onCancelAbort: () => void;
}

const CancelDeliveryButton = ({ onCancel, btnType, onCancelAbort, onCancelAttempt }: CancelDeliveryButtonProps) => {
  const { t } = useTranslation();
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [isCancellationInProgress, setCancellationInProgress] = useState(false);
  return (
    <>
      {showCancelConfirmation && (
        <CancelDeliveryModal
          isVisible={showCancelConfirmation}
          onClose={e => {
            e.stopPropagation();
            onCancelAbort();
            setShowCancelConfirmation(false);
          }}
          onConfirm={(reason: string, customReason?: string) => {
            setCancellationInProgress(true);
            setShowCancelConfirmation(false);
            onCancel(reason, customReason).then(() => {
              setCancellationInProgress(false);
            });
          }}
          data-testid="cancelConfirmationModal"
        />
      )}
      <Button
        loading={isCancellationInProgress}
        data-testid="cancelDeliveryButton"
        block
        type={btnType}
        onClick={(e: MouseEvent<HTMLElement>) => {
          onCancelAttempt();
          e.stopPropagation();
          setShowCancelConfirmation(true);
        }}
      >
        {isCancellationInProgress ? t('deliveries.cancelBtn.textInProgress') : t('deliveries.cancelBtn.text')}
      </Button>
    </>
  );
};

export default CancelDeliveryButton;
